
SJ.Screen = 
class {
  constructor(setup, draw) {

    this._drawableAbsolute = [];
    this._drawable = [];
    this._buttons = [];

    this.draw = draw || this.draw;
    this.setBackgroundColor(color(0, 0, 0));
    setup.call(this, this);
  } 

  setBackgroundColor(bgColor) {
    this.backgroundColor = bgColor;
  }

  draw() {
    push();
      background(this.backgroundColor);

      this._drawable.forEach(obj => {
        if(obj)obj._draw();
        this.lookForAbsolutes(obj);
      });

      this.setAbsolutesPositionInArray();

      this._drawableAbsolute.forEach(obj => {
        if(obj)obj._draw();
      });
    pop();
  }

  onMouseMove() {

    for(let i=this._drawableAbsolute.length - 1; i>=0; i--) {
      const obj = this._drawableAbsolute[i];
      if(obj._mouseMoved()) {
        return true;
      }
    }

    for(let i=this._drawable.length - 1; i>=0; i--) {
      const obj = this._drawable[i];
      if(obj._mouseMoved()) {
        return true;
      }
    }

    return false;
  }
  
  onMousePress() {

    SJ.mainMenuSoundContainer.play('mouseClick');

    for(let i=this._drawableAbsolute.length - 1; i>=0; i--) {
      const obj = this._drawableAbsolute[i];
      if(obj._mousePressed()) {
        return true;
      }
    }

    for(let i=this._drawable.length - 1; i>=0; i--) {
      const obj = this._drawable[i];
      if(obj._mousePressed()) {
        return true;
      }
    }
    
    return false;
  }

  onMouseRelease() {

    for(let i=this._drawableAbsolute.length - 1; i>=0; i--) {
      const obj = this._drawableAbsolute[i];
      if(obj._mouseReleased()) {
        return true;
      }
    }

    for(let i=this._drawable.length - 1; i>=0; i--) {
      const obj = this._drawable[i];
      if(obj._mouseReleased()) {
        return true;
      }
    }

    return false;
  }

  onMouseWheelMove(delta) {

    for(let i=this._drawableAbsolute.length - 1; i>=0; i--) {
      const obj = this._drawableAbsolute[i];
      if(delta < 0){
        if(obj._mouseWheelMoveUp()){
          return true;
        }
      }
      else{
        if(obj._mouseWheelMoveDown()){
          return true;
        }
      }
    }

    for(let i=this._drawable.length - 1; i>=0; i--) {
      const obj = this._drawable[i];
      if(delta < 0){
        if(obj._mouseWheelMoveUp()){
          return true;
        }
      }
      else{
        if(obj._mouseWheelMoveDown()){
          return true;
        }
      }
    }

    for(let i = 0; i < 100; i++)
      this.onMouseMove();

    return false;
  }

  onScreenChange() {
    this._drawable.forEach(e => {
      if(e){
        if(e.onScreenChange){
          e.onScreenChange();
        }
      }
    });
  }

  appendDrawable(obj) {

    obj.parent = this;
    this._drawable.push(obj);

    // this.lookForAbsolutes(obj);
  }

  lookForAbsolutes(obj, show=false){

    if(show)
      console.log(obj);

    if(obj.position === 'absolute'){
      this.moveAbsolute(obj)
    }

    obj.children.forEach(child => {
      this.lookForAbsolutes(child);
    });
  }

  moveAbsolute(obj){

    if(obj.parent !== this){
      const objIndexInParentArray = obj.parent.children.indexOf(obj);
      obj.parent.children.splice(objIndexInParentArray, 1);
    }else{
      const objIndexInParentArray = this._drawable.indexOf(obj);
      this._drawable.splice(objIndexInParentArray, 1);
    }

    obj.parent = this;
    this._drawableAbsolute.push(obj);

  }

  setAbsolutesPositionInArray(){

    const oldArray = this._drawableAbsolute;
    this._drawableAbsolute = [];

    let i = 0;

    oldArray.forEach(element => {

      if(!element.zIndex)
        element.zIndex = i;

      this._drawableAbsolute.push(element);

      i++;

    });

    this._drawableAbsolute.sort((a, b) => {return a.zIndex - b.zIndex});
  }

}